import type { Product } from '@/types';

export const WEEKDAY_ORDER_MON_FIRST = [1, 2, 3, 4, 5, 6, 0] as const;

export const WEEKDAY_I18N_KEY: Record<number, string> = {
  1: 'Products.weekdayMon',
  2: 'Products.weekdayTue',
  3: 'Products.weekdayWed',
  4: 'Products.weekdayThu',
  5: 'Products.weekdayFri',
  6: 'Products.weekdaySat',
  0: 'Products.weekdaySun',
};

export const ALL_GET_DAY_WEEKDAYS: readonly number[] = [0, 1, 2, 3, 4, 5, 6];

const EN_US_LONG_WEEKDAY_TO_GET_DAY: Record<string, number> = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

export function getOrganizationWeekday(
  organizationTimezone: string ,
  at: Date = new Date()
): number {
  const timeZone = organizationTimezone.trim();
  //console.log('at', at);
  try {
    const weekday = new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'long',
    }).format(at);
    return EN_US_LONG_WEEKDAY_TO_GET_DAY[weekday] ?? 0;
  } catch (error) {
    console.error('Error getting organization weekday:', error);
    return at.getUTCDay();
  }
}

export function isProductAvailableToday(
  product: Pick<Product, 'availableWeekdays'>,
  organizationTimezone: string ,
  at: Date = new Date()
): boolean {
  const days = product.availableWeekdays;
  if (days == null) return true;
  if (days.length === 0) return false;
  const today = getOrganizationWeekday(organizationTimezone, at);
  return days.some((d) => Number(d) === today);
}
